import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.flashCardsStepThreeLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.flashCardsStepThreeLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.flashCardsStepThreeLevels.data.flashCardsStepThreeLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
